import { IconButton } from "@mui/material";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { LANGUAGES } from "core/utils/constants";
import TranslateSwapLanguageIcon from "assets/TranslateSwapLanguageIcon";
import { LanguageTranslationContainer } from "../../chat.styled";

export function Language({
    isMenuOpen,
    inputLanguage,
    setInputLanguage,
    outputLanguage,
    setOutputLanguage,
    handleChangeInputLanguage,
    handleChangeOutputLanguage,
}) {
  return (
    <LanguageTranslationContainer
      className={`mb-3 d-flex flex-row h-16 items-center justify-content-between rounded-md border-slate-700 bg-[linear-gradient(110deg,#212121,45%,#27272a,55%,#212121)] bg-[length:200%_100%] px-6 font-medium text-slate-400 transition-colors focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 ${
        isMenuOpen ? "col-md-10" : "col-md-10"
      }`}
      style={{ border: "1px solid" }}
    >
      <FormControl size="small" sx={{ width: "180px" }}>
        <InputLabel id="demo-simple-select-label">Select a language</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={inputLanguage}
          label="inputLanguage"
          onChange={handleChangeInputLanguage}
          variant="outlined"
          sx={{
            "& .MuiSelect-select": {
              width: "110px",
            },
          }}
        >
          {LANGUAGES.map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <IconButton
        onClick={() => {
          setOutputLanguage(inputLanguage);
          setInputLanguage(outputLanguage);
        }}
      >
        <TranslateSwapLanguageIcon />
      </IconButton>
      <FormControl size="small" sx={{ width: "180px" }}>
        <InputLabel id="demo-simple-select-label">Select a language</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={outputLanguage}
          label="outputLanguage"
          onChange={handleChangeOutputLanguage}
          variant="outlined"
          sx={{
            "& .MuiSelect-select": {
              width: "110px",
            },
          }}
        >
          {LANGUAGES.map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </LanguageTranslationContainer>
  );
}
